import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@mobileia/authentication';
import { FuseNavigationService, FuseConfigService } from '@mobileia/layout-fuse';
import { fuseConfig } from './fuse-config';
import { fuseNavigation } from './fuse-navigation';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-system',
  templateUrl: './system.component.html',
  styleUrls: ['./system.component.scss']
})
export class SystemComponent implements OnInit {

  constructor(
    private authService: AuthenticationService,
    private fuseNavigationService: FuseNavigationService,
    private fuseConfigService: FuseConfigService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadUserNav();
    this.initializeUser();
    this.subscribeToLoginState();
  }

  private async initializeUser(): Promise<void> {
    try {
      const user = await this.authService.getUserData().pipe(take(1)).toPromise();
      this.updateToolbarUserName(user);
    } catch (error) {
      console.error('Error loading user data:', error);
    }
  }

  private subscribeToLoginState(): void {
    this.authService.isLoggedIn.subscribe(async (isLogged) => {
      if (!isLogged) return;
      
      await this.loadAndUpdateUser();
    });
  }

  private async loadAndUpdateUser(): Promise<void> {
    try {
      // Try to read stored user data first
      const user = await this.authService.getUserData().pipe(take(1)).toPromise();
      
      if (user && user.firstname) {
        this.updateToolbarUserName(user);
        return;
      }

      // Fallback: request profile from server
      const response = await this.authService.fetchProfile().pipe(take(1)).toPromise();
      
      if (response?.success && response.response?.firstname) {
        this.updateToolbarUserName(response.response);
      }
    } catch (error) {
      console.error('Error loading user profile:', error);
    }
  }

  private updateToolbarUserName(user: any): void {
    if (!user?.firstname) return;

    fuseConfig.layout.toolbar.userName = `Hola ${user.firstname}`;
    this.fuseConfigService.config = fuseConfig;
    this.fuseConfigService.setConfig(fuseConfig);
  }

  loadUserNav() {
    fuseConfig.layout.toolbar.userMenu = [
        {
            id       : 'logout',
            title    : 'Cerrar sesión',
            type     : 'item',
            icon     : 'exit_to_app',
            function: (() => {
              this.authService.signOut();
              setTimeout(() => {
                this.router.navigateByUrl('/').then(data => {
                  window.location.reload();
                });
              }, 2000);
            })
        },
    ];

    //this.fuseConfigService.setConfig(fuseConfig);
    this.fuseConfigService.config = fuseConfig;
    // Register the navigation to the service
    this.fuseNavigationService.register('main', fuseNavigation);
    // Set the main navigation as our current navigation
    this.fuseNavigationService.setCurrentNavigation('main');
  }
}
